import {
  FETCH_SMS,
  FETCH_SMS_SUCCESS,
  FETCH_SMS_FAIL,
  GET_SMS,
  GET_SMS_SUCCESS,
  GET_SMS_FAIL,
  CREATE_SMS,
  CREATE_SMS_SUCCESS,
  CREATE_SMS_FAIL,
  UPDATE_SMS,
  UPDATE_SMS_SUCCESS,
  UPDATE_SMS_FAIL,
  DELETE_SMS,
  DELETE_SMS_SUCCESS,
  DELETE_SMS_FAIL,
} from 'actions/sms';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  sms: [],
  smsDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const smsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_SMS:
    case GET_SMS:
    case CREATE_SMS:
    case DELETE_SMS: {
      return { ...state, isLoading: true, smsDetail: {} };
    }
    case UPDATE_SMS: {
      return { ...state, isLoading: true };
    }
    case FETCH_SMS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        sms: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case GET_SMS_SUCCESS: {
      return {
        ...state,
        smsDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_SMS_SUCCESS: {
      toast.success('SMS added successfully');
      return {
        ...state,
        sms: _.concat(state.sms, payload),
        isLoading: false,
      };
    }

    case UPDATE_SMS_SUCCESS: {
      toast.success('SMS updated successfully');
      return {
        ...state,
        isLoading: false,
        sms: state.sms.map((data) => (data.id === payload.id ? payload : data)),
      };
    }

    case DELETE_SMS_SUCCESS: {
      toast.success('SMS deleted successfully');
      return {
        ...state,
        isLoading: false,
        sms: state.sms.filter((data) => data.id !== payload),
      };
    }

    case FETCH_SMS_FAIL:
    case GET_SMS_FAIL:
    case CREATE_SMS_FAIL:
    case UPDATE_SMS_FAIL:
    case DELETE_SMS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
export default smsReducer;
